<template>
  <h2 class="rlc__subtitle">{{ text }}</h2>
</template>

<script>
  export default {
    name: 'ResentLinkCardSubtitle',
    props: {
      text: {
        type: String,
        default: ''
      }
    }
  };
</script>

<style lang="scss" scoped>
  .rlc__subtitle {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    margin: 8px 0 0 0;
    color: #998f8a;
  }

  @media (max-width: 485px) {
    .rlc__subtitle {
      font-size: 12px !important;
      line-height: 16px !important;
    }
  }
</style>
